/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedRoleSearchResponse } from '../../models/paged-role-search-response';
import { RoleRequestModel } from '../../models/role-request-model';

export interface PostApiRoleV1Search$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: RoleRequestModel
}

export function postApiRoleV1Search$Json(http: HttpClient, rootUrl: string, params?: PostApiRoleV1Search$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedRoleSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiRoleV1Search$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedRoleSearchResponse>;
    })
  );
}

postApiRoleV1Search$Json.PATH = '/private/v1/roles';
